import { useMutation, useQueryClient } from "@tanstack/react-query";

import { revokeSession } from "./api";

// Отзыв одной сессии по id. Инвалидируем список — строка исчезнет из
// таблицы (или, если отозвали текущую, следующий запрос упадёт в 401 и
// authedFetch разлогинит).
export function useRevokeSession(): ReturnType<
  typeof useMutation<void, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (sessionId) => revokeSession(sessionId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["sessions"],
      });
    },
  });
}
